<template>
  <div @click="openAnswers" class="wrapper">
    <div class="filter-box">
      <p v-if="!checkedAnswers.length">{{ parseTranslation(ADD_ANSWERS) }}</p>

      <div v-else>
        <span
          class="answer-pill"
          v-for="(answer, index) in checkedAnswers"
          :key="answer.code"
        >
          {{ answer.label }}

          <button @click="checkedAnswers.splice(index, 1)">
            <img src="@/assets/imgs/x_dark.svg" />
          </button>
        </span>
      </div>
    </div>

    <div
      class="answers"
      :class="{ active: showAnswers, 'no-search': isCity && step === 'state' }"
    >
      <div class="answers-top">
        <button ref="filterBoxReturn" @click="back">
          <img
            ref="filterBoxReturnImg"
            src="@/assets/imgs/arrow_dark.svg"
            alt="Returns"
          />
          {{ parseTranslation(RETURN) }}
        </button>

        <button ref="filterBoxClose" @click="showAnswers = false">
          <img ref="filterBoxCloseImg" src="@/assets/imgs/x_dark.svg" alt="Close" />
        </button>
      </div>

      <div
        v-if="(!isCity || step === 'city') && searchAnswers.length"
        class="answers-search"
      >
        <input v-model="search" type="text" placeholder="Search" />
      </div>

      <div class="answer">
        <div v-if="!isCity || step === 'city'" class="answer-scroll">
          <div class="empty-answers" v-if="!searchAnswers.length">
            {{ parseTranslation(VALIDATION_APPLY_COUNTRY) }}
          </div>

          <div class="answer-item" v-for="answer in searchAnswers" :key="answer.code">
            <input
              type="checkbox"
              :id="answer.code"
              :value="answer"
              v-model="checkedAnswers"
            />

            <label :for="answer.code">{{ answer.label }}</label>
          </div>
        </div>

        <div v-else-if="states" class="answer-scroll">
          <div v-for="state in states" :key="state.code">
            <div @click="selectState(state.code)" class="state">
              {{ state.label }}

              <img src="@/assets/imgs/arrow_dark.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loaderCities">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import Loader from '@/components/loading/Loader-2'

import * as translationFilterBox from './FilterBox.translations'

const { default: translations, ...translationKeys } = translationFilterBox

export default {
  props: {
    filter: {
      required: true,
    },
    id: {
      required: true,
    },
    selected: {
      default: null,
    },
    states: {
      default: null,
    },
    loaderCities: {
      default: false,
    },
    getStateCallback: {
      default: () => {},
    },
    setGeoValuesCallback: {
      default: () => {},
    },
  },

  components: { Loader },

  data() {
    return {
      translations,
      ...translationKeys,
      showAnswers: false,
      checkedAnswers: [],
      searchAnswers: [],
      search: '',
      step: 'state',
      isCity: false,
      selectedState: [],
    }
  },

  watch: {
    filter() {
      this.showAnswers = this.step === 'city'

      this.searchAnswers = this.filter.answers
      this.isCity = this.id === 'ows-17'
    },

    selected() {
      if (this.selected) this.checkedAnswers = this.selected
    },

    search() {
      if (this.search && this.search !== '') {
        this.searchAnswers = this.filter.answers.filter(item => {
          return this.search
            .toLowerCase()
            .split(' ')
            .every(search => item.label.toLowerCase().includes(search))
        })
      } else {
        this.searchAnswers = this.filter.answers
      }
    },

    checkedAnswers() {
      this.setGeoValuesCallback(this.checkedAnswers)
    },
  },

  methods: {
    ...mapActions(['setState']),

    back() {
      if (this.step !== 'city') this.showAnswers = false
      else this.step = 'state'
    },

    selectState(state) {
      this.step = 'city'
      this.getStateCallback(state)
      this.setState(state)
    },

    openAnswers({ currentTarget, target }) {
      if (
        target !== this.$refs.filterBoxReturn &&
        target !== this.$refs.filterBoxClose &&
        target !== this.$refs.filterBoxCloseImg &&
        target !== this.$refs.filterBoxReturnImg
      )
        this.showAnswers = true

      this.outsideClick(currentTarget, ['click'], () => {
        this.showAnswers = false
      })
    },

    outsideClick(element, events, callback) {
      const html = document.documentElement
      const outside = 'data-outside'

      if (!element.hasAttribute(outside)) {
        events.forEach(userEvent => {
          setTimeout(() => {
            html.addEventListener(userEvent, e => {
              if (!element.contains(event.target)) {
                element.removeAttribute(outside)
                events.forEach(userEvent => {
                  html.removeEventListener(userEvent, this.handleOutsideClick)
                })
                callback()
              }
            })
          })
        })
        element.setAttribute(outside, '')
      }
    },
  },

  created() {
    this.searchAnswers = this.filter.answers
    this.isCity = this.id === 'ows-17'
    if (this.selected) this.checkedAnswers = this.selected
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  width: 100%;
}

.filter-box {
  border: 1px solid $gray-light-8;
  border-radius: 3px;
  padding: 20px;
  min-height: 60px;
  cursor: pointer;
  width: 100%;

  div {
    display: flex;
    flex-wrap: wrap;
  }
  p {
    position: absolute;
    @include tipography(16);
    color: $white;
    margin: 0;
  }

  .light & {
    p {
      color: $gray-2;
    }
  }
}

.answers {
  width: 100%;
  position: absolute;
  display: none;
  animation: show 0.5s forwards;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  padding: 20px;
  margin-top: 10px;
  background: $white;
  z-index: 1;
  bottom: -290px;
  &.no-search {
    bottom: -250px;
  }
  &.active {
    display: block;
  }
  .answers-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      display: flex;
      align-items: center;
      background: none;
      border: none;
      cursor: pointer;
      &:nth-of-type(1) {
        text-decoration: underline;
        @include tipography(16);
        color: $gray-8;
        img {
          transform: rotate(-90deg);
          width: 10px;
          margin-right: 5px;
        }
      }
      transition: all 0.3 ease;
      &:hover {
        transform: scale(1.05);
      }
      &:focus {
        outline: none;
      }
    }
  }
  .answers-search {
    margin-top: 10px;
    input {
      width: 100%;
      border: 1px solid $gray-light-8;
      border-radius: 3px;
      padding: 5px;
      @include tipography(16);
      color: $gray-2;
      &:focus {
        outline: none;
      }
    }
  }
  .answer {
    padding: 10px;
    margin-top: 10px;
    background: $gray-light-4;
    .answer-scroll {
      height: 150px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 10px;
        height: 40px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #fff;
      }
      .empty-answers {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .answer-item {
        display: flex;
        align-items: center;
        padding: 2px 0;
        label {
          @include tipography(16);
          color: $gray-2;
          margin-left: 5px;
        }
      }
    }
  }
}

.answer-pill {
  display: flex;
  align-items: center;
  background: $gray-5;
  padding: 0px 6px 0px 10px;
  border-radius: 30px;
  margin: 5px;
  @include tipography(12);
  color: $gray-2;
  button {
    position: relative;
    top: 2px;
    border: none;
    background: none;
    padding: 5px;
    cursor: pointer;
    &:focus {
      outline: none;
    }
    img {
      height: 12px;
    }
  }
}

.state {
  display: flex;
  align-items: center;
  @include tipography(16);
  color: $gray-8;
  cursor: pointer;
  padding: 5px 8px;
  margin-right: 5px;
  img {
    width: 10px;
    transform: rotate(90deg);
    margin-left: 5px;
  }
  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
}
</style>
